import React from 'react';
import { LoginAsPage } from './LoginAsPage';

export default function LoginAsPageCustom(props) {
    return (
        <LoginAsPage 
            customCompanyName='varamar'
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/LoginAsPage/LoginAsPageCustom.jsx